import axios from "axios";

const url = "https://beauti-services.herokuapp.com/services";
// const url = "http://localhost:6600/services";

export const fetchServicesRequest = () => axios.get(url);
